import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { residentSchApi, schErr } from "@/lib/schApi";
import ScheduleList, { SevenDayStrip } from "@/components/nds/windows/sch/ScheduleList";

const btn = "px-3 py-1.5 rounded-sm font-mono text-[10px] tracking-[0.18em] uppercase border transition-colors";

/** Resident portal: 7-day strip, full personal schedule (read-only mandatory), Available Sessions to self-book. */
export default function ResidentMySchedule({ token, sessionsOnly = false }) {
  const api = residentSchApi(token);
  const [mine, setMine] = useState(null);
  const [open, setOpen] = useState([]);
  const [busy, setBusy] = useState("");
  const load = () => Promise.all([api.get("/portal/resident/schedule"), api.get("/portal/resident/available")])
    .then(([a, b]) => { setMine(a.events); setOpen(b.events); }).catch((e) => toast.error(schErr(e)));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const act = async (id, path, msg) => {
    setBusy(id);
    try { await api.post(path); toast.success(msg); await load(); }
    catch (e) { const d = e?.response?.data?.detail; toast.error(d?.message || schErr(e)); } finally { setBusy(""); }
  };
  if (!mine) return <p className="text-white/50 text-sm">Loading your schedule…</p>;
  return (
    <section data-testid="portal-schedule" className="space-y-5">
      {!sessionsOnly && <><h2 className="text-xs uppercase tracking-[0.3em] text-[#d4a017]">My schedule</h2>
      <SevenDayStrip events={mine} prefix="portal-schedule" onOpen={(e) => document.querySelector(`[data-testid="portal-schedule-item-${e.id}"]`)?.scrollIntoView({ behavior: "smooth", block: "center" })} />
      <ScheduleList events={mine} prefix="portal-schedule" empty="Nothing on your schedule in the next 60 days."
        action={(e) => (e.can_cancel
          ? <button type="button" disabled={busy === e.id} onClick={() => act(e.id, `/portal/resident/cancel/${e.id}`, "Booking cancelled")} data-testid={`portal-schedule-cancel-${e.id}`} className={`${btn} border-red-400/40 text-red-300 hover:bg-red-500/10`}>Cancel</button>
          : <span className="font-mono text-[9px] uppercase text-white/40">{e.is_mandatory ? "Required" : "Assigned by staff"}</span>)} /></>}
      <h2 className="text-xs uppercase tracking-[0.3em] text-[#d4a017] pt-2">Available sessions</h2>
      <ScheduleList events={open} prefix="portal-available" empty="No open sessions right now. Check back soon."
        action={(e) => <button type="button" disabled={busy === e.id} onClick={() => act(e.id, `/portal/resident/book/${e.id}`, "You're booked")} data-testid={`portal-available-book-${e.id}`} className={`${btn} border-[#d4a017]/60 text-[#d4a017] hover:bg-[#d4a017]/10`}>{busy === e.id ? "Booking…" : "Book"}</button>} />
    </section>
  );
}
